module.exports = __webpack_public_path__ + "img/back-arrow.4d5a9bbb.svg";